(function () {
  const WISHLIST_ENDPOINT = '/apps/wishlist';

  let wishlist = [];
  let wishlistProducts = [];
  let wishlistLoaded = false;

  // ---------------------------------------------
  // FIND ALL WISHLIST BUTTONS
  // ---------------------------------------------

  function getWishlistButtons() {
    return document.querySelectorAll('.mc-wishlist-button');
  }

  // ---------------------------------------------
  // UPDATE HEART APPEARANCE
  // ---------------------------------------------

  function updateWishlistButtons() {
    getWishlistButtons().forEach((button) => {
      const productId = button.dataset.productId;
      const isWishlisted = wishlist.includes(productId);

      button.classList.toggle('is-wishlisted', isWishlisted);

      button.setAttribute(
        'aria-label',
        isWishlisted
          ? 'Remove from wishlist'
          : 'Add to wishlist'
      );

      // Do not use a title attribute.
      // This prevents the browser tooltip appearing.
      button.removeAttribute('title');
    });
  }

  // ---------------------------------------------
  // FORMAT PRODUCT PRICE
  // ---------------------------------------------

  function formatPrice(price) {
    if (!price || price.amount == null) {
      return '';
    }

    const amount = Number(price.amount);

    if (Number.isNaN(amount)) {
      return '';
    }

    try {
      return new Intl.NumberFormat('en-ZA', {
        style: 'currency',
        currency: price.currencyCode || 'ZAR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return 'R ' + amount.toFixed(2);
    }
  }

  // ---------------------------------------------
  // ESCAPE HTML
  // ---------------------------------------------

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  // ---------------------------------------------
  // RENDER WISHLIST PAGE
  // ---------------------------------------------

  function renderWishlistPage() {
  const page = document.querySelector('#mc-wishlist-page');

  if (!page) {
    return;
  }

  const loading = page.querySelector(
    '.mc-wishlist-page__loading'
  );

  const empty = page.querySelector(
    '.mc-wishlist-page__empty'
  );

  const productsContainer = page.querySelector(
    '[data-wishlist-products]'
  );

  if (!empty || !productsContainer) {
    return;
  }

  if (loading) {
    loading.hidden = true;
  }

  if (!wishlist.length) {
    empty.hidden = false;
    productsContainer.hidden = true;
    productsContainer.innerHTML = '';
    return;
  }

  const products = wishlistProducts.filter(
    (product) =>
      product &&
      product.id &&
      wishlist.includes(product.id)
  );

  if (!products.length) {
    empty.hidden = false;
    productsContainer.hidden = true;
    productsContainer.innerHTML = '';
    return;
  }

  empty.hidden = true;
  productsContainer.hidden = false;

  productsContainer.innerHTML = products
    .map((product) => {
      const title = escapeHtml(product.title);
      const url = escapeHtml(product.url || '#');
      const price = formatPrice(product.price);

      const image =
        product.image && product.image.url
          ? `
            <img
              src="${escapeHtml(product.image.url)}"
              alt="${escapeHtml(
                product.image.altText || product.title
              )}"
              loading="lazy"
              class="product-item__primary-image"
            >
          `
          : '';

      return `
        <div
          class="product-item product-item--vertical mc-wishlist-product"
          data-wishlist-card="${escapeHtml(product.id)}"
        >

          <button
            type="button"
            class="mc-wishlist-button"
            data-product-id="${escapeHtml(product.id)}"
            aria-label="Remove from wishlist"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M12 21s-7.5-4.35-9.6-8.7C.8 8.95 2.4 5 6.4 5c2.25 0 3.65 1.25 4.45 2.35C11.65 6.25 13.05 5 15.6 5c4 0 5.6 3.95 4 7.3C17.5 16.65 12 21 12 21z"
              />
            </svg>
          </button>

          <a
            href="${url}"
            class="product-item__image-wrapper"
          >
            <div class="aspect-ratio aspect-ratio--square">
              ${image}
            </div>
          </a>

          <div class="product-item__info">
            <div class="product-item__info-inner">

              <a
                href="${url}"
                class="product-item__title text--strong link"
              >
                ${title}
              </a>

              <div class="product-item__price-list price-list">
                <span class="price">
                  ${escapeHtml(price)}
                </span>
              </div>

              <span class="product-item__inventory ${
  product.available
    ? 'inventory inventory--high'
    : 'inventory'
}">
  ${
    product.available
      ? 'In stock'
      : 'Sold out'
  }
</span>

</div>

<div class="product-item__action-list button-stack">

  ${
    !product.available
      ? `
        <button
          type="button"
          class="product-item__action-button button button--small button--disabled"
          disabled
        >
          Sold out
        </button>
      `
      : product.hasMultipleVariants
        ? `
          <a
            href="${url}"
            class="product-item__action-button button button--small button--primary"
          >
            Choose options
          </a>
        `
        : `
          <button
            type="button"
            class="product-item__action-button button button--small button--primary mc-wishlist-add-cart"
            data-variant-id="${escapeHtml(product.variantId || '')}"
          >
            Add to cart
          </button>
        `
  }

  <button
    type="button"
    class="product-item__action-button button button--small button--ternary hidden-phone mc-wishlist-quick-view"
    data-product-url="${url}"
  >
    Quick view
  </button>

</div>

</div>

</div>
      `;
    })
    .join('');

  updateWishlistButtons();
}

  // ---------------------------------------------
  // LOAD CUSTOMER WISHLIST
  // ---------------------------------------------

  async function loadWishlist() {
    try {
      const response = await fetch(WISHLIST_ENDPOINT, {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        },
        credentials: 'same-origin'
      });

      const data = await response.json();

      if (response.status === 401 || data.loggedIn === false) {
        wishlist = [];
        wishlistProducts = [];
        wishlistLoaded = true;

        updateWishlistButtons();
        renderWishlistPage();

        return;
      }

      if (!response.ok || !data.success) {
        console.warn('MC Auto Wishlist:', data);
        return;
      }

      wishlist = Array.isArray(data.wishlist)
        ? data.wishlist
        : [];

      wishlistProducts = Array.isArray(data.products)
        ? data.products
        : [];

      wishlistLoaded = true;

      updateWishlistButtons();
      renderWishlistPage();

    } catch (error) {
      console.error(
        'MC Auto Wishlist could not be loaded:',
        error
      );
    }
  }

  // ---------------------------------------------
  // ADD OR REMOVE PRODUCT
  // ---------------------------------------------

  async function toggleWishlist(button) {
    const productId = button.dataset.productId;

    if (!productId) {
      return;
    }

    // Make sure we know the current wishlist first
    if (!wishlistLoaded) {
      await loadWishlist();
    }

    const currentlyWishlisted =
      wishlist.includes(productId);

    const action =
      currentlyWishlisted ? 'remove' : 'add';

    button.disabled = true;
    button.classList.add('is-loading');

    try {
      const response = await fetch(WISHLIST_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          productId: productId,
          action: action
        })
      });

      const data = await response.json();

      if (response.status === 401) {
        window.location.href =
          '/account/login?return_url=' +
          encodeURIComponent(window.location.pathname);

        return;
      }

      if (!response.ok || !data.success) {
        throw new Error(
          data.error || 'Wishlist update failed'
        );
      }

      wishlist = Array.isArray(data.wishlist)
        ? data.wishlist
        : [];

      wishlistLoaded = true;

      // If an item was removed, remove it from
      // our locally cached product details too.
      if (action === 'remove') {
        wishlistProducts = wishlistProducts.filter(
          (product) => product.id !== productId
        );
      }

      updateWishlistButtons();
      renderWishlistPage();

    } catch (error) {
      console.error(
        'MC Auto Wishlist update failed:',
        error
      );

      alert(
        'We could not update your wishlist. Please try again.'
      );

    } finally {
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  }

  // ---------------------------------------------
// ADD TO CART FROM WISHLIST
// ---------------------------------------------

async function addWishlistProductToCart(button) {
  const variantId = button.dataset.variantId;

  if (!variantId) {
    return;
  }

  const numericVariantId =
    variantId.split('/').pop();

  button.disabled = true;

  const originalText = button.textContent;

  button.textContent = 'Adding...';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(numericVariantId),
            quantity: 1
          }
        ]
      })
    });

    if (!response.ok) {
      throw new Error('Could not add product to cart');
    }

    button.textContent = 'Added to cart';

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true
      })
    );

    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 1500);

  } catch (error) {
    console.error(
      'MC Auto Wishlist add to cart failed:',
      error
    );

    button.textContent = originalText;
    button.disabled = false;

    alert(
      'We could not add this product to your cart. Please try again.'
    );
  }
}

  // ---------------------------------------------
  // HEART CLICK
  // ---------------------------------------------

  document.addEventListener('click', function (event) {
    const button =
      event.target.closest('.mc-wishlist-button');

    if (!button) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    toggleWishlist(button);
  });

  // ---------------------------------------------
  // INITIAL LOAD
  // ---------------------------------------------

  function initialiseWishlist() {
    const hasWishlistButtons =
      getWishlistButtons().length > 0;

    const hasWishlistPage =
      document.querySelector('#mc-wishlist-page');

    if (hasWishlistButtons || hasWishlistPage) {
      loadWishlist();
    }
  }

  // Add to cart
document.addEventListener('click', function (event) {
  const button =
    event.target.closest('.mc-wishlist-add-cart');

  if (!button) {
    return;
  }

  event.preventDefault();

  addWishlistProductToCart(button);
});

// Quick view
document.addEventListener('click', function (event) {
  const button =
    event.target.closest('.mc-wishlist-quick-view');

  if (!button) {
    return;
  }

  event.preventDefault();

  const productUrl =
    button.dataset.productUrl;

  if (!productUrl) {
    return;
  }

  // Use the theme's existing quick-view system.
  button.setAttribute(
    'data-action',
    'open-modal'
  );

  button.setAttribute(
    'data-secondary-action',
    'open-quick-view'
  );

  button.setAttribute(
    'aria-controls',
    'modal-quick-view-wishlist'
  );

  // Fallback if the theme does not initialise
  // dynamically generated quick-view buttons.
  window.location.href = productUrl;
});

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseWishlist
    );
  } else {
    initialiseWishlist();
  }

  // Shopify can dynamically reload sections.
  document.addEventListener(
    'shopify:section:load',
    function () {
      updateWishlistButtons();

      if (!wishlistLoaded) {
        loadWishlist();
      } else {
        renderWishlistPage();
      }
    }
  );
})();